<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Dialpad Meetings Star" class="d-icon d-icon--dialpad-meetings-star" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M7.398 1.176a2.25 2.25 0 0 1 2.25 2.25v.842l.045-.03 1.387-.788c.41-.233.92.063.92.535V8.01a.616.616 0 0 1-.928.531l-1.386-.815c-.014-.008-.025-.018-.038-.027v.875a2.25 2.25 0 0 1-2.25 2.25H2.25A2.25 2.25 0 0 1 0 8.574V3.426a2.25 2.25 0 0 1 2.25-2.25h5.148Zm-.53 4.906c-.176-.269-.571-.475-.985-.475-.891 0-1.53.707-1.53 1.683 0 .976.639 1.69 1.53 1.69.414 0 .81-.213.985-.482v.42h.729V4.342h-.729v1.74Zm-.865.156c.47 0 .821.345.865.84v.412c-.044.495-.395.858-.865.858-.527 0-.904-.438-.904-1.064 0-.626.377-1.046.904-1.046ZM3.706 2.764c-.008-.051-.098-.064-.117-.016-.3.925-.95 1.648-1.814 2.001-.041.02-.033.09.012.102.68.163 1.209.768 1.327 1.527.008.05.092.062.11.015.346-.967 1.008-1.695 1.85-1.979.043-.02.034-.095-.012-.105-.697-.155-1.24-.772-1.356-1.545Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconDialpadMeetingsStar',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: '500',
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(s),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
